export class PriceListOtherItem {
    id: number = -1;

    priceListId: number = -1;
    gradeId: number = -1;
    type: number = -1;
    name: string = '';
    price: number = 0;
    afterAmount: number = 0;
    unitId: number = -1;
    siteId: number = -1;
    active: boolean = false;
    createdBy: number = -1;
    
    createdAt: string = '';
    updatedAt: string = '';
  
}